import {
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@mui/material';
import CodeBlock from '../../CodeBlock';
import { Link } from 'react-router-dom';

function SubmitDdsEndpoint() {
  return (
    <Box sx={{ textAlign: 'left' }}>
      <Typography variant="body1" paragraph>
        Creates a new DDS statement in the EUDR system. This endpoint handles all submission types
        (Domestic, Import, Export, Trade) with proper validation based on activity type.
      </Typography>

      <Typography variant="h6" sx={{ fontWeight: 'bold', mt: 2 }}>
        Activity Type Requirements
      </Typography>
      <p>
        <strong>Allowed values:</strong> DOMESTIC, IMPORT, EXPORT, TRADE<br />
      </p>
      <p>
        <strong>IMPORT/EXPORT must include:</strong>
      </p>
      <ul>
        <li>netWeight (in kilograms)</li>
        <li>producers array with geolocation data (GeoJSON base64)</li>
      </ul>


      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mt: 2 }}>
        Endpoint
      </Typography>
      <CodeBlock code="POST /api/eudr/dds" />

      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mt: 2 }}>
        Request Body Structure
      </Typography>
      <Typography variant="body1" paragraph>
        The structure of the request body depends on the specified `activityType`. Key fields vary for
        different operations:
      </Typography>
      <ul>
          <li><strong>DOMESTIC:</strong> Primarily requires details about the operator and commodities within a single country.</li>
          <li><strong>IMPORT/EXPORT:</strong> Requires `netWeight` and detailed `producers` information including geolocation.</li>
          <li><strong>TRADE:</strong> Requires `associatedStatements` linking to previous DDS submissions.</li>
      </ul>
      <Typography variant="body1" paragraph>
        Please refer to the specific documentation sections for <a href="/docs#submission/domestic">Domestic</a>, <a href="/docs#submission/import">Import</a>, and <a href="/docs#submission/trade">Trade</a> submissions for detailed request body examples and required fields.
      </Typography>

      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mt: 2 }}>
        Validation Rules
      </Typography>
      <ul>
        <li>{'HS codes must be 2-8 digits matching pattern ^[0-9]{2,8}'}$</li>
        <li>Country codes must be from approved EU list (AT, BE, FR, DE, etc.)</li>
        <li>{'EORI numbers must match pattern ^[A-Za-z]{2}[0-9A-Za-z]{1,15}$'}</li>
        <li>GeoJSON must be encoded as base64</li>
      </ul>

      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mt: 2 }}>
        Response
      </Typography>
      <CodeBlock
        code={`{
  "status": "success",
  "httpStatus": 201,
  "data": {
    "ddsIdentifier":  "3f09ab3f-4c97-4663-8463-89d58f1d646b" 
    } 
  }
}`}
      />

      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mt: 2 }}>
        Response Codes
      </Typography>
      <TableContainer component={Paper} sx={{ mt: 1 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Code</TableCell>
              <TableCell>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>201</TableCell>
              <TableCell>DDS statement successfully created</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>400</TableCell>
              <TableCell>Bad request - missing or invalid parameters</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>401</TableCell>
              <TableCell>Unauthorized - invalid credentials</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>500</TableCell>
              <TableCell>Server error</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box >
  );
}

export default SubmitDdsEndpoint; 